import { toast } from "react-toastify";

import { nextCargoApi } from "../../baseApi";
import { AttendancesTodayRaw, AttendancesTodayResult } from "./attendances.types";

export const attendancesApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    getAttendancesTodayByCompany: build.query<AttendancesTodayRaw, Pick<AttendancesTodayResult, "id">, AttendancesTodayResult>({
      query: ({ id }) => `/attendances/today/company/${id}`,
      transformResponse: (result) => {
        return {
          ...result,
          isInAttendance: result?.id && result.status ? result.id : 0
        };
      }
    }),
    saveAttendances: build.mutation<void, { user: { id: number }; company: { id: number } }>({
      query: (body) => ({
        url: "/attendances/save",
        method: "POST",
        body
      }),
      onQueryStarted: (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          pending: "Iniciando atendimento...",
          success: "Atendimento iniciado com sucesso!",
          error: "Erro ao iniciar atendimento"
        });
      }
    }),
    updateAttendances: build.mutation<void, { id: number }>({
      query: (body) => ({
        url: `/attendances/update`,
        method: "PUT",
        body
      }),
      onQueryStarted: async (args, { queryFulfilled }) => {
        const toastId = toast.loading("Encerrando atendimento...");
        try {
          await queryFulfilled;
          toast.update(toastId, {
            render: "Atendimento encerrado com sucesso!",
            type: "success",
            isLoading: false,
            autoClose: 3000
          });
        } catch (error) {
          const err = (error as any)?.error?.data?.message || "Erro ao encerrar atendimento";
          toast.update(toastId, {
            render: err,
            type: "error",
            isLoading: false,
            autoClose: 3000
          });
        }

        /* toast.promise(queryFulfilled, {
          pending: "Encerrando atendimento...",
          success: "Atendimento encerrado com sucesso!",
          error: (error) => {
            console.log("updateAttendances", error);
            return "Erro ao encerrar atendimento";
          }
        }); */
      }
    })
  })
});

attendancesApi.enhanceEndpoints({
  addTagTypes: ["Expedition", "Attendances"],
  endpoints: {
    getAttendancesTodayByCompany: {
      providesTags: (result, error, { id }) => [{ type: "Attendances", id }]
    },
    saveAttendances: {
      invalidatesTags: ["Expedition", "SyncExpedition"]
    },
    updateAttendances: {
      invalidatesTags: ["Expedition", "SyncExpedition"]
    }
  }
});
